import React, { useState } from 'react'
import { CSVLink } from 'react-csv'

import Header from '_components/header/index.jsx'
import parseReports from '_lib/parseReports.js'
import { logErrorAsync } from '_lib/utility'
import { getAllLastUpdatedReports } from '_services/audience'

const HEADERS = [
  { label: 'User', key: 'created_by' },
  { label: 'Updated At', key: 'updated_at' },
  { label: 'Deck', key: 'label' },
]

const STYLE = { display: 'block', fontSize: '2rem', margin: '0 auto', maxWidth: 'fit-content' }

// page
const AudienceInsightsReportPage = () => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)

  const handleGenerateReport = () => {
    setLoading(true)
    getAllLastUpdatedReports()
      .then((allReports) => {
        allReports.forEach((report) => (report.name = report.audience_name || report.report_name))
        allReports = parseReports(allReports)
        const reports = allReports.map(({ label, created_by, updated_at }) => ({
          label,
          created_by: created_by || 'unknown',
          updated_at: updated_at.split('T')[0],
        }))
        setData(reports)
      })
      .catch((error) => {
        logErrorAsync(error)
        toast.error(error.message)
      })
      .finally(() => setLoading(false))
  }

  return (
    <div id="audience-insights-report">
      <Header
        title="Audience Insights — Report"
        actions={[
          {
            children: 'Generate report',
            onClick: handleGenerateReport,
          },
        ]}
      />

      {loading && <p style={STYLE}>Loading...</p>}

      {data && !loading && (
        <CSVLink
          data={data}
          headers={HEADERS}
          filename={`Insights Report - ${new Date().toISOString().split('T')[0]}.csv`}
          style={STYLE}
        >
          Download Report
        </CSVLink>
      )}
    </div>
  )
}

// export
export default AudienceInsightsReportPage
